import React from "react";
import styles from "./priceFAQ.module.scss";

const faqs = {
  elektroschrottpreis: [
    {
      question: "Wie werden Elektroschrottpreis berechnet?",
      answer: (
        <p>
          Tatsächlich kann sich der Verkauf von Elektroschrott auch für
          Privatpersonen lohnen, denn es sind seltene und wertvolle Metalle in
          Elektrogeräten verarbeitet. Per Definition fallen in die Kategorie
          Elektroschrott alle ausgedienten Geräte, die mit Strom aus der
          Steckdose, einer Batterie oder Solarzellen betreiben wurden. Die
          Ankaufspreise richten sich hier nach den enthaltenen Metallgehalten im
          Elektroschrott. Die Menge der jeweiligen Gold-, Silber-, Palladium-
          und Kupfergehalte ist von Leiterplatte zu Leiterplatte oder von Chip
          zu Chip unterschiedlich. Deshalb gibt es genaue Sortierkriterien und
          Preisgruppen für die verschiedenen Sorten. Verbraucherinnen und
          Verbraucher dürfen den Elektroschrott nicht über den Hausmüll
          entsorgen, sondern müssen ihn bei einem Wertstoffhof oder Schrottplatz
          abgeben. Im Elektronikmüll sind viele umweltgefährdende und
          hochgiftige Stoffe wie Schwermetalle und halogenierte Dioxine
          enthalten, sodass die Aufarbeitung nur durch einen zertifizierten
          Fachbetrieb erfolgen darf.
        </p>
      ),
    },
    {
      question: "Wie entstehen die Elektroschrottpreis von Schrott24?",
      answer: (
        <p>
          Größere Mengen an Elektroschrott, etwa aus der gewerblichen Nutzung,
          werden von den Schrotthändlern meist gut bezahlt, da darin wertvolle
          Rohstoffe wie etwa Edelmetalle enthalten sind. Auf unserer Website
          sehen Sie die aktuellen Preise für Elektroschrott. Um den besten Preis
          für Elektroschrott zu erhalten, ist es wichtig, die Sorten vor dem
          Verkauf genau voneinander zu trennen. Wir haben für Sie als
          Hilfestellung für die genaue Sortierung der Leiterplatten, CPUs und
          anderer Bauteile Erklärvideos erstellt. Diese finden Sie auf unserem
          Youtube-Kanal.
        </p>
      ),
    },
  ],

  eisenpreise: [
    {
      question: "Wie werden Eisen- und Stahlpreise berechnet?",
      answer: (
        <p>
          Die Grundpreise für die Legierungsbestandteile werden an der Börse
          gehandelt. Wichtige Faktoren, die den Stahlpreis beeinflussen, sind
          die Nachfrage der Stahlproduzenten, internationale Ein- und
          Ausfuhrzölle und die Preispolitik großer Produzenten und Kartelle. Die
          Neugewinnung von Stahl, benötigt doppelt soviel Energie wie das
          Recycling von Stahl. Aufgrund der hohen Wirtschaftlichkeit wird somit
          der Großteil des Eisenschrotts dem Recyclingprozess zugeführt.
        </p>
      ),
    },
    {
      question: "Wie entstehen die Eisenpreise von Schrott24?",
      answer: (
        <p>
          Unsere Eisenpreise hängen mit dem Angebot und der Nachfrage zusammen.
          Auf unserem Online-Portal können Sie unsere aktuellen Eisenpreise
          ansehen. Wir unterscheiden die Preise für Mischschrott und
          Schwerschrott
        </p>
      ),
    },
    {
      question: "Was ist Eisen  und wo kommt es vor?",
      answer: (
        <p>
          Das graue, metallisch glänzende Eisen weist ein hohes Gewicht auf und
          ist magnetisch. Sobald eine Rostschicht auf dem Eisen erkennbar ist,
          ist die Zuordnung relativ einfach und man kann es leicht von dem
          rostfreien Edelstahl oder Hartmetall unterscheiden. Eisen kommt zum
          Beispiel bei Eisenstangen und -blechen, Bremsscheiben, I-Trägern,
          Gittern, Rosten, Werkzeugen, Ambossen etc. vor.{" "}
        </p>
      ),
    },
  ],

  elektroschrottpreise: [
    {
      question: "Wie werden Elektroschrottpreise berechnet?",
      answer: (
        <p>
          Tatsächlich kann sich der Verkauf von Elektroschrott auch für
          Privatpersonen lohnen, denn es sind seltene und wertvolle Metalle in
          Elektrogeräten verarbeitet. Per Definition fallen in die Kategorie
          Elektroschrott alle ausgedienten Geräte, die mit Strom aus der
          Steckdose, einer Batterie oder Solarzellen betreiben wurden. Die
          Ankaufspreise richten sich hier nach den enthaltenen Metallgehalten im
          Elektroschrott. Die Menge der jeweiligen Gold-, Silber-, Palladium-
          und Kupfergehalte ist von Leiterplatte zu Leiterplatte oder von Chip
          zu Chip unterschiedlich. Deshalb gibt es genaue Sortierkriterien und
          Preisgruppen für die verschiedenen Sorten. Verbraucherinnen und
          Verbraucher dürfen den Elektroschrott nicht über den Hausmüll
          entsorgen, sondern müssen ihn bei einem Wertstoffhof oder Schrottplatz
          abgeben. Im Elektronikmüll sind viele umweltgefährdende und
          hochgiftige Stoffe wie Schwermetalle und halogenierte Dioxine
          enthalten, sodass die Aufarbeitung nur durch einen zertifizierten
          Fachbetrieb erfolgen darf.
        </p>
      ),
    },
    {
      question: "Wie entstehen die Elektroschrottpreise von Schrott24?",
      answer: (
        <p>
          Größere Mengen an Elektroschrott, etwa aus der gewerblichen Nutzung,
          werden von den Schrotthändlern meist gut bezahlt, da darin wertvolle
          Rohstoffe wie etwa Edelmetalle enthalten sind. Auf unserer Website
          sehen Sie die aktuellen Preise für Elektroschrott. Um den besten Preis
          für Elektroschrott zu erhalten, ist es wichtig, die Sorten vor dem
          Verkauf genau voneinander zu trennen. Wir haben für Sie als
          Hilfestellung für die genaue Sortierung der Leiterplatten, CPUs und
          anderer Bauteile Erklärvideos erstellt. Diese finden Sie auf unserem
          Youtube-Kanal.
        </p>
      ),
    },
  ],

  batteriepreise: [
    {
      question: "Wie entsorgt man Bleibatterien?",
      answer: (
        <p>
          Bleibatterien werden vorwiegend als Batterien in Fahrzeugen jeglicher
          Art eingesetzt. Diese KFZ-Batterien sind bis zu 10 Jahre
          einsatzbereit. Wichtig ist nach der langen Lebensdauer, dass die
          Batterien sachgerecht entsorgt werden, denn Sie enthalten schädliche
          Stoffe für die Umwelt. Die Entsorgung der Bleibatterien wird über den
          Schrotthändler abgewickelt. Wenn Sie beispielsweise als KFZ-Betrieb
          mehrerer Batterien pro Jahr haben, können sie diese gesammelt an
          Schrott24 verkaufen.
        </p>
      ),
    },
    {
      question: "Bleibatterien Ankauf und Preise",
      answer: (
        <p>
          Der Batteriepreis orientiert sich am Bleipreis. Dieser ist wiederum
          von den Metallpreisen an der Börse abhängig, die sich stetig
          verändern. Auf der Schrott24 Plattform können sie die tagesaktuellen
          Bleipreise und Batteriepreise sehen und direkt im Shop verkaufen. Wir
          kaufen alte Batterien in Deutschland, Österreich und in der Schweiz
          an.
        </p>
      ),
    },
  ],

  kabelpreise: [
    {
      question: "Wie werden Kabelpreise berechnet?",
      answer: (
        <p>
          Da der Anteil von Kupfer in Kabeln hoch ist, hängt der Kabelpreis mit
          dem Kupferpreis zusammen. 1 kg reines Kupfer liegt durchschnittlich
          zwischen 4 und 6 Euro. Der tatsächliche Preis hängt allerdings von der
          Kupferart, welche sich beispielsweise in Kupfer Millberry, Kupfer
          Kerze, Kupfer Berry und Kupferkabel mit oder ohne Stecker unterteilt,
          ab. Kupfer wird an der London Metal Exchange gehandelt und ist
          abhängig von den Entwicklungen am Weltmarkt sowie dem aktuellen
          Angebot und der Nachfrage.
        </p>
      ),
    },
    {
      question: "Wie entstehen die Kabelpreise von Schrott24?",
      answer: (
        <p>
          Gründsätzlich gilt: Je höher der Kupferanteil in den Kabeln ist, desto
          wertvoller ist das Material und umso höhere Preise bekommt man für das
          Material. Beim Verkauf von Kabelschrott ist es zusätzlich wichtig,
          dass dieser nach den einzelnen Sorten getrennt wird. Wenn Sie die
          Trennarbeiten übernehmen, d.h. Kabelschrott abisolieren, können Sie
          einen höheren Preis erzielen. Sie sehen unsere aktuellen Kabelpreise
          auf unserer Website.{" "}
        </p>
      ),
    },
    {
      question: "Was ist Kupfer und wo kommt Kupfer vor?",
      answer: (
        <p>
          Kupfer ist ein rötliches, relativ weiches und gut formbares
          Schwermetall. Es ist rostfrei und nicht magnetisch. An der Luft läuft
          Kupfer an und wird rötlich-braun, mit der Zeit bildet sich durch
          weitere Verwitterung an der Oberfläche eine bläulich-grüne
          Oxidationsschicht bzw. Patina. Kupfer kommt aufgrund seiner
          hervorragenden Leiteigenschaften in Elektroinstallationen aller Art
          und Kabeln vor. Im Dachbau wird Kupfer häufig eingesetzt, da es
          aufgrund der entstehenden Patina Schicht das Kupferblech vor weiterer
          Korrosion schützt und eine sehr lange Lebensdauer besitzt.{" "}
        </p>
      ),
    },
  ],

  schrottpreise: [
    {
      question: "Wie liegen die Schrottpreise?",
      answer: (
        <p>
          Schrottpreise sind abhängig von Angebot und Nachfrage und der
          aktuellen Situation auf der London Metal Exchange, der Börse für
          Metalle. Zudem weisen die Altmetallsorten verschiedene Qualitäten auf.
          Das heißt, je besser die Qualität und Reinheit des Altmetalls ist,
          umso besser ist auch der Schrottpreis. Verkauft man sein Altmetall
          nicht sortenrein, sondern vermischt es mit anderen Sorten oder
          Qualitäten, wird aufgrund der aufwendigen Sortierung nur der Preis der
          niedrigsten Qualität ausgezahlt. Damit man den besten Schrottpreis für
          sein Material bekommt, empfiehlt es sich, die tagesaktuellen
          Metallkurse zu beobachten und das Altmetall beim Verkauf sortenrein
          und in die verschiedenen Qualitäten zu trennen. Meist sind die Preise
          für Tonnen besser als für Mengen im Kilobereich. Deshalb sammeln viele
          Verkäufer ihr Altmetall über einen längeren Zeitraum. Es gibt keine
          fixen Preise für alle Güter und Gewichtsklassen. Außerdem ist es
          wichtig zu wissen, wie man die Schrottsorten untereinander richtig in
          die einzelnen Qualitäten trennt. Denn nur so bekommt man einen guten
          Preis für Schrott. Mehr Tipps, wie Sie den besten Schrottpreis
          bekommen, bekommen Sie auf unserem Blog oder auf Youtube.
        </p>
      ),
    },
    {
      question: "Wie entstehen die Schrottpreise von Schrott24?",
      answer: (
        <p>
          Durch unser großes Partnernetzwerk aus Schrotthändlern können wir
          bessere Schrottpreise anbieten.Wir matchen mithilfe unserer
          intelligenten Tools dynamisch das Angebot und die Nachfrage der
          Altmetalle. Auf unserer Plattform veröffentlichen wir die
          tagesaktuellen Schrottpreise. Diese können sich aufgrund Ihres
          Standortes und der gewählten Transportart noch anpassen. In jedem Fall
          wird der Preis für zu verkaufenden Schrott anhand des Schrottgewichts
          und der Sorte ermittelt. Um den besten Schrottpreis zu bekommen, ist
          es wichtig, die Sorten voneinander zu trennen. In unserem Webshop
          können Sie die Preise für folgende Altmetalle ansehen:
          <br />• Aluminiumpreis - Alublech, Aluprofile, Alufelgen, Aluguss,...
          <br />• Bleipreis - Bleibatterien, Bleigewichte
          <br />• Edelstahlpreis -V2A, V4A,...
          <br />• Eisenpreis &amp; Stahlpreis - Mischschrott, Schwerschrott
          <br />• Hartmetallpreis - Widia, Bohrer, Fräser, HSS, ...
          <br />• Kabelpreis
          <br />• Kupferpreis- Millberry, Berry, Kerze, ...
          <br />• Messingpreis - MS58, Späne, Patronen, ...
          <br />• Legierungen - Bronze, Rotguss, ...
          <br />• Zinkpreis
          <br />• Zinnpreis - Geschirrzinn, Lötzinn, ...
          <br />• Elektroschrottpreis - CPU, Leiterplatten, Trafos, ...
          <br />
        </p>
      ),
    },
  ],
  hartmetallpreis: [
    {
      question: "Wie werden Hartmetallpreise berechnet?",
      answer: (
        <p>
          Der Hartmetallpreis pro Kilo liegt meist zwischen 10 und 12 Euro. Da
          Hartmetall eine Legierung ist, werden die Legierungsbestandteile an
          der Börse gehandelt. Der Preis ist von diesen Entwicklungen abhängig.
        </p>
      ),
    },
    {
      question: "Wie entstehen die Hartmetallpreise von Schrott24?",
      answer: (
        <p>
          Durch unser großes Partnernetzwerk aus Schrotthändlern können wir
          bessere Hartmetallpreise anbieten.Wir matchen mithilfe unserer
          intelligenten Tools dynamisch das Angebot und die Nachfrage. Das
          Recycling von Hartmetall spart erhebliche Energieressourcen, die bei
          der Primärgewinnung im Bergbau und beim Transport der Erze entstünden,
          ein. So können durch Recycling knappe Ressourcen geschont und
          gleichzeitig Energiekosten und CO2 Emissionen verringert werden.
          Dadurch ist Hartmetall eine oft unterschätzte Geldquelle. Auf unserer
          Homepage können Sie Widia, Sägeblätter, Bohrer und Fräser sowie
          gemischtes Hartmetall und Späne verkaufen. Wichtig ist, das Material
          sortenrein zu verkaufen, um den besten Preis zu bekommen. Da es aber
          oft zu Verwechslungen mit anderen Metallen kommt, haben wir ein
          Erklärvideo, das Ihnen bei der Sortierung helfen kann, auf unserem
          Youtube Kanal bereitgestellt.
        </p>
      ),
    },
    {
      question: "Was ist Hartmetall und wo kommt es vor?",
      answer: (
        <p>
          Hartmetall ist eine Metallverbindung, die zu 80% aus Wolfram und zu
          knapp 12% aus Cobalt besteht und kein Eisen enthält. Aufgrund seiner
          Zusammensetzung ist Hartmetall enorm hitzebeständig sowie extrem hart
          und wird als Werkzeug zur Bearbeitung von anderen harten Stoffen
          eingesetzt. Hartmetall ist spröde und sehr schwer. Hartmetall kann
          Glas zerkratzen. Durch die Härte und Langlebigkeit verwendet man VHM
          beispielsweise für Sägeblätter, Fräser und Bohrer und
          Wendeschneidplatten. Die Legierung hat somit nichts mit gewöhnlichem
          Stahl oder Eisen zu tun.
        </p>
      ),
    },
  ],
  edelstahlpreis: [
    {
      question: "Wie werden Edelstahlpreise berechnet?",
      answer: (
        <p>
          Edelstahl ist eine Legierung aus Chrom und Nickel. Aus diesem Grund
          hängt der Edelstahlpreis stark mit dem Nickelpreis an der Metallbörse
          zusammen. Wie bei allen Metallen gilt: je reiner das Material ist,
          desto besser ist es für die Zuführung in den Recyclingprozess geeignet
          und desto höhere Preise werden beim Verkauf erzielt. Auch bei
          Edelstahl hängt der Preis, wie bei nahezu allen anderen Rohstoffen
          bzw. Produkten, von Angebot und Nachfrage ab. Weitere Faktoren, die
          den Edelstahlpreis beeinflussen sind:
          <br />
          Angebot und Nachfrage
          <br />
          Qualität des Edelstahlschrotts
          <br />
          Gegebenheiten der internationalen Märkte
          <br />
          politische und wirtschaftliche Lage
          <br />
          Schrottmenge
          <br />
        </p>
      ),
    },
    {
      question: "Wie entstehen die Schrott24 Edelstahlpreise?",
      answer: (
        <p>
          Durch unser großes Netzwerk aus Schrotthändlern können wir bessere
          Schrottpreise anbieten. So können wir auf das Angebot und die
          Nachfrage an Edelstahl besser reagieren. Auf unserer Plattform
          veröffentlichen wir die tagesaktuellen Edelstahlpreise. Diese können
          sich aufgrund Ihres Standortes und der gewählten Transportart noch
          anpassen.
        </p>
      ),
    },
    {
      question: "Was ist Edelstahl und wo kommt Edelstahl vor?",
      answer: (
        <p>
          Bei Edelstahl handelt es sich um eine Legierung, die sehr gut recycelt
          werden kann. Dieser Vorgang lässt sich zudem beliebig oft wiederholen.
          V2A und V4A Stahl sind Bezeichnungen für spezielle
          Edelstahllegierungen mit genau definierter Zusammensetzung. Edelstahl
          hat eine glänzend silbrige Farbe und ist meist rostfrei. Ob Edelstahl
          magnetisch ist oder nicht, hängt von der Legierung ab. Edelstahl wird
          überall dort, wo man korrosionsbeständige, temperaturbeständige und
          hygienische Materialien braucht, eingesetzt.
        </p>
      ),
    },
  ],
  zinkpreis: [
    {
      question: "Wie werden Zinkpreise berechnet?",
      answer: (
        <p>
          Zink wird an der London Metal Exchange und der Shanghai Metal Exchange
          gehandelt. Da sich Blei, Zinn und Zink optisch sehr ähneln, haben wir
          auf unserem Youtube Kanal ein Erklärvideo zur Unterscheidung der
          Materialien hochgeladen.
        </p>
      ),
    },
    {
      question: "Wie entstehen die Zinkpreise von Schrott24?",
      answer: (
        <p>
          Durch unser großes Partnernetzwerk aus Schrotthändlern können wir
          bessere Zinkpreise anbieten.Wir matchen mithilfe unserer intelligenten
          Tools dynamisch das Angebot und die Nachfrage von Zink. Auf unserer
          Plattform veröffentlichen wir die tagesaktuellen Schrottpreise für
          neues und altes Zink. Um einen guten Preis für das Material zu
          erzielen, ist es wichtig, die Zinksorten voneinander getrennt zu
          verkaufen. Sein Bruch ist silberweiß und an der Luft bildet es eine
          Schutzschicht aus Zinkoxid und -carbonat. Zinkblech sollte mit
          feuerverzinktem Stahlblech nicht verwechselt werden, welches
          fälschlich oft Zinkblech oder Weißblech genannt wird. Um den besten
          Preis für Zink zu erzielen, achten Sie darauf, die verschiedenen
          Sorten getrennt voneinander anzuliefern.
        </p>
      ),
    },
    {
      question: "Was ist Zink und wo kommt es vor?",
      answer: (
        <p>
          Zink ist ein bläulich-weißes Metall, das sich durch seine hohe
          Korrosionsbeständigkeit auszeichnet. Sein Bruch ist silberweiß und an
          der Luft bildet es eine Schutzschicht aus Zinkoxid und -carbonat.
          Zinkblech sollte mit feuerverzinktem Stahlblech nicht verwechselt
          werden, welches fälschlich oft Zinkblech oder Weißblech genannt wird.
          Es wird vor allem zum Schutz anderer Metalle eingesetzt. Gewonnen wird
          es vor allem in Australien, Kanada, China, Peru und den USA. Für die
          Verzinkung von Metallen werden 53% der Zinkproduktion aufgewendet. Aus
          21% der Produktion werden Produkte aus reinem Zink hergestellt. 18%
          fließen in die Messingherstellung.
        </p>
      ),
    },
  ],
  messingpreise: [
    {
      question: "Wie werden Messingpreise berechnet?",
      answer: (
        <p>
          Der Preis für Messing liegt zwischen dem von Kupfer und Zink. Da
          Messing eine Legierung ist, ist der Messingpreis vom Kupferpreis an
          der Börse abhängig. Allerdings hängt der endgültige Preis von den
          tagesaktuellen Entwicklungen an der Börse ab. Die Legierung aus Kupfer
          und Zink kann gut recycelt werden, ohne Qualitätseinbußen hinnehmen zu
          müssen.
        </p>
      ),
    },
    {
      question: "Wie entstehen die Messingpreise von Schrott24?",
      answer: (
        <p>
          Je nach Legierungszusammensetzung kann Messing unterschiedliche
          Eigenschaften annehmen und auch verschiedene Preise haben. Durch unser
          großes Partnernetzwerk aus Schrotthändlern können wir bessere
          Schrottpreise anbieten, da wir auf das Angebot und die Nachfrage von
          Messing reagieren können. Auf unserer Plattform veröffentlichen wir
          die tagesaktuellen Messingpreise.
        </p>
      ),
    },
    {
      question: "Was ist Messing und wo kommt Messing vor?",
      answer: (
        <p>
          Je nach Zinkgehalt hat Messing eine bräunlich-rötliche (ab ca. 20%
          Zinkanteil), über goldfarbene bis hin zu hellgelber (ab ca. 36%
          Zinkanteil) Farbe. Messing zählt neben Bronze und Rotguss zu den drei
          häufigsten Kupferlegierungen und besteht aus Kupfer und Zink.
          Recyceltes Messing besitzt keinen Qualitätsnachteil gegenüber den aus
          Erzen hergestellten Metallen. Messing ist als moderner Werkstoff in
          der Industrie gefragt und ist ein idealer Wärmeleiter und sehr
          korrosionsbeständig. Weil Messing sehr edel wirkt, werden daraus
          Türgriffe, Armaturen, Lampen, Kunstgegenstände, Beschläge und
          Scharniere hergestellt. Der Hauptteil des Messingschrotts fällt in
          Handwerksbetrieben, die Messing verarbeiten, an. Dort entstehen
          Messingstücke und Messingspäne durch das Zersägen, Feilen und
          Schleifen von Messing.
        </p>
      ),
    },
  ],
  aluminiumpreis: [
    {
      question: "Wie werden Aluminiumpreise berechnet?",
      answer: (
        <p>
          Neben Kupfer ist Aluminium das am stärksten gehandelte
          Industriemetall. Bei der Herstellung von Aluminium fällt ein hoher
          Energieverbrauch an. Aufgrund der hohen Energiekosten bei der
          Aluminiumgewinnung korreliert der Aluminiumpreis häufig mit dem
          Ölpreis. Wichtigster Marktplatz für Aluminium ist die London Metal
          Exchange. Der Alupreis pro Kilo ist abhängig von den Entwicklungen an
          dieser Börse und variiert täglich. Je reiner das Material, desto
          besser ist es für die Zuführung in den Recyclingprozess geeignet und
          desto höhere Preise werden beim Verkauf erzielt. Je nach dem Grad der
          Verunreinigung und dem Mischverhältnis des Schrotts verändert sich
          auch der Preis entsprechend.
        </p>
      ),
    },
    {
      question: "Wie entstehen die Aluminiumpreise von Schrott24?",
      answer: (
        <p>
          Der Aluminiumpreis hängt vom aktuellen Angebot, der Nachfrage und den
          Entwicklungen an der Börse ab. Bei Schrott24 können Sie die aktuellen
          Aluminiumpreise für verschiedenste Sorten online ansehen und
          berechnen. Wer sein altes Aluminium zu einem guten Preis verkaufen
          möchte, sollte dafür sorgen, Reste von anderen Materialien und starke
          Verschmutzungen möglichst vorab zu entfernen. Wie Sie selbst den
          besten Schrottpreis erzielen, erfahren Sie auf unserem Blog oder auf
          unserem Youtube-Kanal.
          <br />
          Was ist Aluminium und wo ist es enthalten?
          <br />
          Aluminium ist das dritthäufigste Element und das häufigste Metall in
          der Erdkruste. Aluminium ist ein silbrig-weißes Leichtmetall. Alu hat
          ein verhältnismäßig geringes Gewicht, ist rostfrei und nicht
          magnetisch. Aufgrund der guten Eigenschaften von Aluminium kann es gut
          verarbeitet werden und wird in vielen Bereichen als Werkstoff
          eingesetzt. Man findet es beispielsweise in Alufelgen, Aludosen,
          Alublechen, Aluprofilen uvm. Da der sogenannte Bauxit-Abbau im
          Tagewerk erfolgt, ist es umso wichtiger, Aluminium zu recyceln und die
          Ressourcen damit zu schonen.
        </p>
      ),
    },
  ],
  bleipreise: [
    {
      question: "Wie werden Bleipreise berechnet?",
      answer: (
        <p>
          Das Bleierz war jahrelang die bedeutendste kommerzielle Quelle für die
          Gewinnung von neuem Blei. Heute kommt deutlich mehr als die Hälfte des
          weltweiten Bleibedarfs aus dem Recycling von Bleischrott. Der
          Bleipreis wird, wie jeder andere Altmetallpreis, von vielen
          verschiedenen Faktoren beeinflusst. Wie bei allen Altmetallen gilt: je
          reiner das Material ist, desto besser ist es für die Zuführung in den
          Recyclingprozess geeignet und desto höhere Preise werden beim Verkauf
          erzielt.
        </p>
      ),
    },
    {
      question: "Wie entstehen die Schrott24 Bleipreise?",
      answer: (
        <p>
          Der Bleipreis hängt in erster Linie vom Neumetallpreis an der Börse
          ab. Auf unserer Website veröffentlichen wir täglich die aktuellen
          Bleipreise. Durch unser großes Partnernetzwerk aus Schrotthändlern
          können wir bessere Schrottpreise anbieten, da wir das Angebot mit der
          Nachfrage matchen. Sie können Ihr Altblei online verkaufen und bei
          einem Partner-Schrotthändler in Ihrer Nähe anliefern oder es abholen
          lassen. Mehr Tipps, wie Sie den besten Schrottpreis erzielen, erhalten
          Sie auf unserem Blog oder auf unserem Youtube-Kanal.
        </p>
      ),
    },
    {
      question: "Was ist Blei und wo kommt Blei vor?",
      answer: (
        <p>
          Blei ist ein bläulich-graues, sehr gut verformbares Schwermetall.
          Durch das Ankratzen der Oberfläche kommt für kurze Zeit eine matt
          silbrige Farbe zum Vorschein, weil es an der Luft chemisch reagiert
          und eine graue Oxidationsschicht bildet. Blei ist schwer und nicht
          magnetisch. Der Großteil der Bleigewinnung wird zur Herstellung von
          Akkumulatoren (Batterieteilen) verwendet.
        </p>
      ),
    },
  ],
  zinnpreis: [
    {
      question: "Wie werden Zinnpreise berechnet?",
      answer: (
        <p>
          Für den Recyclingprozess und für den Zinnpreis beim Verkauf gilt: je
          reiner das Material ist, desto besser. Der Zinn Schrottpreis hängt von
          vielen Faktoren ab. Bei Schrott24 können Sie sich über den aktuellen
          Zinnpreis pro kg und die Entstehung des Zinnpreises informieren. Durch
          unser großes Partnernetzwerk aus Schrotthändlern können wir bessere
          Zinnpreise anbieten. Wir matchen mithilfe unserer intelligenten Tools
          dynamisch das Angebot und die Nachfrage der Altmetalle. Auf unserer
          Plattform veröffentlichen wir die tagesaktuellen Schrottpreise.
        </p>
      ),
    },
    {
      question: "Was ist Zinn und wo kommt Zinn vor?",
      answer: (
        <p>
          Zinn hat eine silberweiße Farbe, ist rostfrei und nicht magnetisch.
          Als Legierungsbestandteil wird Zinn vielfältig verwendet,
          beispielsweise mit Kupfer legiert wird es zu Bronze. Als Bestandteil
          von Metall-Legierungen mit niedrigem Schmelzpunkt ist es unersetzlich.
          Zinn kommt als Altlot, Zinnkrätze, Zinnoxide, Zinnanoden oder Lötzinn
          vor. Zinn wird durch die optische Ähnlichkeit oft mit Blei oder Zink
          verwechselt. Der Unterschied zwischen den Materialien ist bei genauer
          Betrachtung leicht zu erkennen. Zinn kann man leicht biegen und es
          bildet "Beulen", d.h. es bricht nicht wie das ähnlich weiche Blei.
          Zudem ist Blei verhältnismäßig schwerer als Zinn und Zink. Im
          Gegensatz zu Zinn oder Blei kann man Zink nicht verbiegen und es
          bricht auch nicht. Schlägt man es gegen eine Kante, federt es. Da sich
          Blei, Zinn und Zink optisch sehr ähneln, haben wir auf unserem Youtube
          Kanal ein Erklärvideo zur Unterscheidung der Materialien hochgeladen.
        </p>
      ),
    },
  ],
  kupferpreis: [
    {
      question: "Wie werden Kupferpreise berechnet?",
      answer: (
        <p>
          1 kg reines Kupfer liegt durchschnittlich zwischen 4 und 6 Euro. Der
          tatsächliche Preis hängt allerdings von der Kupferart, welche sich
          beispielsweise in Kupfer Millberry, Kupfer Kerze, Kupfer Berry und
          Kupferkabel mit oder ohne Stecker unterteilt, ab. Zudem nimmt die
          tagesaktuelle Entwicklung an der London Metal Exchange Einfluss auf
          die Kupferpreisentwicklungen. Besonders hat die Nachfrage nach Kupfer
          auf dem Weltmarkt Einfluss auf den Kupferpreis. Ist mehr Kupfer von
          der Industrie für die Fertigung gefragt, als zur Verfügung steht , so
          ist es schnell der Fall, dass der Kupferpreis auf dem Weltmarkt
          steigt.
        </p>
      ),
    },
    {
      question: "Wie entstehen die Kupferpreise von Schrott24?",
      answer: (
        <p>
          Durch unser großes Partnernetzwerk aus Schrotthändlern können wir
          bessere Schrottpreise anbieten.Wir matchen mithilfe unserer
          intelligenten Tools dynamisch das Angebot und die Nachfrage der
          Kupfersorten. Auf unserer Plattform veröffentlichen wir die
          tagesaktuellen Kupferpreise. Diese können sich aufgrund Ihres
          Standortes und der gewählten Transportart noch anpassen. Wie bei allen
          Altmetallen gilt: je reiner das Kupfer ist, desto besser ist es für
          die Zuführung in den Recyclingprozess geeignet und desto höhere Preise
          werden beim Verkauf erzielt. Achten Sie darauf, die Kupfersorten vor
          dem Verkauf von einander zu trennen und zu sortieren! Ansonsten wird
          immer nur der Preis der geringsten Schrottqualität berechnet. Auf
          unserem Blog und auf unserem YouTube Kanal habe wir als Hilfestellung
          für die Sortierung einige Erklärvideos für Sie bereitgestellt.
        </p>
      ),
    },
    {
      question: "Was ist Kupfer und wo kommt Kupfer vor?",
      answer: (
        <p>
          Kupfer ist ein rötliches, relativ weiches und gut formbares
          Schwermetall. Es ist rostfrei und nicht magnetisch. An der Luft läuft
          Kupfer an und wird rötlich-braun, mit der Zeit bildet sich durch
          weitere Verwitterung an der Oberfläche eine bläulich-grüne
          Oxidationsschicht bzw. Patina. Kupfer wird weltweit abgebaut, aber die
          größten wirtschaftlich förderbaren Reserven liegen derzeit in Chile
          und den USA. Weltweit wird mehr als ein Zehntel, in Deutschland sogar
          fast die Hälfte, der Kupferproduktion über energiesparendes Recycling
          gedeckt. Kupfer kommt aufgrund seiner hervorragenden Leiteigenschaften
          in Elektroinstallationen aller Art und Kabeln vor. Im Dachbau wird
          Kupfer häufig eingesetzt, da es wegen der entstehenden Patina Schicht
          das Kupferblech vor weiterer Korrosion schützt und eine sehr lange
          Lebensdauer aufweist. Die Nachfrage wächst zunehmend, dadurch ist der
          Recyclingprozess für viele eine Geldquelle.
        </p>
      ),
    },
  ],
  stahlpreise: [
    {
      question: "Wie werden Stahlpreise berechnet?",
      answer: (
        <p>
          Der Stahlpreis setzt sich aus Legierungselementen, Stahlschrott und
          Koks zusammen. Die Grundpreise für die Legierungsbestandteile werden
          an der Börse gehandelt. Wichtige Faktoren, die den Stahlpreis
          beeinflussen, sind die Nachfrage von den Stahlproduzenten,
          internationale Ein- und Ausfuhrzölle und die Preispolitik großer
          Produzenten und Kartelle. Die Neugewinnung von Stahl benötigt doppelt
          soviel Energie wie das Recycling von Stahl. Wegen der hohen
          Wirtschaftlichkeit wird somit der Großteil des Eisenschrotts dem
          Recyclingprozess zugeführt.
        </p>
      ),
    },
    {
      question: "Wie entstehen die Stahlpreise von Schrott24?",
      answer: (
        <p>
          Unsere Stahlpreise hängen mit dem Angebot und der Nachfrage zusammen.
          Auf unserem Online-Portal können Sie unsere aktuellen Stahlpreise
          ansehen. Wir unterscheiden die Preise für Mischschrott und
          Schwerschrott
        </p>
      ),
    },
    {
      question: "Was ist Stahl und wo kommt es vor?",
      answer: (
        <p>
          Was ist Stahl und wo kommt es vor? Das graue, metallisch glänzende
          Eisen weist ein hohes Gewicht auf und ist magnetisch. Sobald eine
          Rostschicht auf dem Eisen erkennbar ist, ist die Zuordnung relativ
          einfach und man kann es leicht von dem rostfreien Edelstahl oder
          Hartmetall unterscheiden. Eisen kommt zum Beispiel in Eisenstangen und
          -blechen, Bremsscheiben, I-Trägern, Gittern, Rosten, Werkzeugen,
          Ambossen usw. vor.
        </p>
      ),
    },
  ],
};

const PriceFAQ = ({ page }) => (
  <div className={styles.wContainer}>
    {page && faqs[page]
      ? faqs[page].map(item => (
          <div className={styles.textGroupContainer}>
            <div>
              <div className={styles.orangeLine}></div>
            </div>
            <div>
              <h2>{item.question}</h2>
              {item.answer}
            </div>
          </div>
        ))
      : null}
  </div>
);

export default PriceFAQ;
